import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import LoadingSpinner from '@/components/common/LoadingSpinner';
import { useAuth } from '@/auth/AuthProvider';
import { useAuthConfig } from '@/hooks/useAuthConfig';
import { useProfile } from '@/hooks/useProfile';
import { msalEnabled } from '@/auth/AuthProvider';
import { getStoredToken } from '@/auth/localToken';

export default function AuthGate({ children }: { children: ReactNode }) {
  const location = useLocation();
  const { data: config, isLoading: configLoading } = useAuthConfig();
  const { isAuthenticated, isLoading: authLoading } = useAuth();
  const { data: profile, isLoading: profileLoading } = useProfile(
    Boolean(config?.auth_enforced && (msalEnabled ? isAuthenticated : getStoredToken())),
  );

  if (configLoading || authLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <LoadingSpinner message="Loading..." />
      </div>
    );
  }

  if (!config?.auth_enforced) {
    return <>{children}</>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (profileLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <LoadingSpinner message="Loading profile..." />
      </div>
    );
  }

  if (profile?.must_change_password && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }

  return <>{children}</>;
}
